﻿export function addToGTMDataLayer(errorMessage, gtmEvent, gtmPageTrigger) {

    //Write message to GTM tag dataLayer
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': gtmEvent,
        'pageTrigger': gtmPageTrigger,
        'error_message': errorMessage,
    });
}
